/*!

=========================================================
* - v1.4.0
=========================================================

* Product Page: 
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import MediaQuery from 'react-responsive'

import SelfTicketsTalbe from  "../components/TicketTables/selfTktsTable"
import SelfTicketsCard from  "../components/TicketTables/selfTktsCard"




class AgentTable extends React.Component {
  render() {


    return (
      <>
        <PanelHeader size="sm" />
        <div>
          <Row>
            <Col md={12}>
              <Card>

                <CardBody className="all-icons">
                <MediaQuery minDeviceWidth={1244}>
                <SelfTicketsTalbe  tktstates="History"/> 

                  </MediaQuery>

                  <MediaQuery maxDeviceWidth={1244} >
                <SelfTicketsCard  tktstates="History"/> 

                  </MediaQuery>



                  
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default AgentTable;


